import React from "react";
import { makeRootController } from "./controllers/_root.controller";
export var RootControllerInstance = makeRootController();
RootControllerInstance.$init();
export var RootContext = React.createContext(RootControllerInstance);
